module.exports = __webpack_public_path__ + "assets/img/player_play_w.2e32394c.png";